export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              关于我们
            </span>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6">
              亲亲漫画网 · 漫画爱好者的全集阅读平台
            </h2>
            <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
              <p>
                亲亲漫画网诞生于对漫画的热爱，我们深知追更的痛苦——等一周只为看一话，断更更是让人心焦。因此，我们决定打造一个专注<strong>漫画全集</strong>的阅读平台，只收录已完结的优质日漫和韩漫，让每一位读者都能享受一次性看完整部作品的畅快体验。
              </p>
              <p>
                平台采用创新的<strong>下拉式全集阅读</strong>模式，摒弃传统翻页设计，只需向下滑动即可连贯浏览全部章节。无论电脑还是手机，都能获得流畅无阻的阅读体验。目前我们已收录超过5000部完结漫画，涵盖热血、恋爱、奇幻、悬疑、校园、都市等丰富题材，且每日持续补充新完结作品。
              </p>
              <p>
                我们坚持<strong>完全免费</strong>的原则，不设付费墙、不做强制广告，让漫画回归纯粹的阅读乐趣。亲亲漫画网，就是你想看全集时第一个想到的地方。
              </p>
            </div>
          </div>
          <div className="flex-shrink-0 w-full max-w-sm">
            <div className="aspect-square rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20reading%20corner%20with%20open%20manga%20books%20and%20warm%20lamp%20light%2C%20soft%20textiles%2C%20comfortable%20armchair%2C%20Japanese%20manga%20volumes%20stacked%20neatly%2C%20warm%20cream%20and%20terracotta%20tones%2C%20inviting%20atmosphere%2C%20high%20quality%20editorial%20photography&width=800&height=800&seq=about-manga-01&orientation=squarish"
                alt="亲亲漫画网 - 温馨的漫画阅读场景"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}